import { useTranslation } from 'react-i18next'
import { Button, ExternalLink, Flex, Icon, Typography } from '@percent/lemonade'
import { CONTACT_CUSTOMER_SERVICE_FORM_LINK } from '@percent/cause-dashboard/constants/support'
import styles from './GrantAdvisoryBookingModal.module.scss'

type SupportRedirectScreenProps = {
  onClose: () => void
  onSupportLinkClick: () => void
}

// Shown instead of the eligibility questions when the user came with a support query.
// AgentPro specialists can't help with support, so the only way forward is the support form.
export const SupportRedirectScreen = ({ onClose, onSupportLinkClick }: SupportRedirectScreenProps) => {
  const { t } = useTranslation()

  return (
    <div className={`${styles.questionnaireFrame} ${styles.stepEnter}`}>
      <Flex direction="column" align="center" gap={16} data-testid="grant-questionnaire-support-redirect">
        <Icon name="info" size={8} color="gray400" />
        <Typography variant="h4" className={styles.centeredText}>
          {t('grantAdvisoryQuestionnaire.supportRedirect.title')}
        </Typography>
        <Typography variant="small" $color="gray500" className={styles.centeredText}>
          {t('grantAdvisoryQuestionnaire.supportRedirect.description')}
        </Typography>
        <ExternalLink
          href={CONTACT_CUSTOMER_SERVICE_FORM_LINK}
          text={t('grantAdvisoryQuestionnaire.supportRedirect.raiseTicket')}
          onClick={onSupportLinkClick}
        />
        <Button variant="primary" stretch onClick={onClose} data-testid="grant-questionnaire-support-redirect-close">
          {t('grantAdvisoryQuestionnaire.supportRedirect.close')}
        </Button>
      </Flex>
    </div>
  )
}
